const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/uiActions.ts';
import { MessageDescriptor } from 'react-intl';
import { SnackbarProps } from '@mui/material';
import { LogSeverity } from './logActions';

export const atShowSnackbar = 'SHOW_SNACKBAR';
export const atDismissSnackbar = 'DISMISS_SNACKBAR';
export const atShowUncaughtErrorDialog = 'SHOW_UNCAUGHT_ERROR';
export const atDismissUncaughtErrorDialog = 'DISMISS_UNCAUGHT_ERROR';

export type DialogWidth = 'content' | 'dynamic' | 'full' | 'fullWidth'; // FIXME: find out what 'fullWidth' does and possibly remove

/**
 * Causes a snackbar to be shown.
 * @param message An entry from an intl textmap, or a string that has already been internationalised
 * @param options Object to map keys with replacement texts. Ignored if message is a string
 * @param logAs If this is defined, the message will by logged to ClientLog by loggingSaga if the product uses it
 */
export function showSnackbar(
    message: MessageDescriptor | string,
    options?: { messageOpt?: any; uiOpts?: Partial<SnackbarProps> },
    logAs?: LogSeverity
) {
    return {
        type: atShowSnackbar,
        message,
        options,
        logAs,
    };
}

export type ShowSnackbarAction = ReturnType<typeof showSnackbar>;

export function dismissSnackbar() {
    return {
        type: atDismissSnackbar,
    };
}

/**
 * Causes an uncaught error dialog to be shown. The error will also be logged by loggingSaga.
 * @param location Location of error (e.g. 'saga', 'reducer'...). Only shown in dev mode.
 * @param exception
 * @param message error message (optional)
 * @param textMapId entry from UncaughtErrorDialog's textMap
 */
export function showUncaughtErrorDialog(
    location: string | null,
    exception: Error | null,
    message?: string | null,
    textMapId?: string | null
) {
    return {
        type: atShowUncaughtErrorDialog,
        location,
        message: message || (exception && `${exception}`),
        textMapId: textMapId || null,
        stack: exception?.stack ?? new Error().stack,
    };
}

export type ShowUncaughtErrorDialogAction = ReturnType<typeof showUncaughtErrorDialog>;

export function dismissUncaughtErrorDialog() {
    return {
        type: atDismissUncaughtErrorDialog,
    };
}
